import type { ISalesCounterpartFetchApi } from 'apiConnector/counterpart/counterpart';
import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';
import styled from 'styled-components';

const UserPreferencesFormLazy = lazyWithRetry(() => import('./UserPreferencesForm'));

interface Props {
  onClose: () => void;
  clientSearchApi: ISalesCounterpartFetchApi;
}

const StyledDiv = styled.div`
  height: 600px;
`;

function Fallback() {
  return (
    <StyledDiv>
      <LazyFallback />
    </StyledDiv>
  );
}

export function UserPreferencesFormWithSuspense({ onClose, clientSearchApi }: Props) {
  return (
    <Suspense fallback={<Fallback />}>
      <UserPreferencesFormLazy onClose={onClose} clientSearchApi={clientSearchApi} />
    </Suspense>
  );
}
